<div class="ui segment"  appMargin marginB="3" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start stretch" >
	<div fxFlex="5%">
		   <sui-checkbox >
            </sui-checkbox>
	</div>
		<div fxFlex="25%">{{organizationType?.organizationTypeName}}</div>
		<div fxFlex>{{organizationType?.organizationTypeDescription}}</div>
		<div fxFlex  class="text-right">
				<button *isPermitted="{id:'ADMIN_ORGANIZATION_TYPE',action:'edit'}"  class="ui circular tiny button" (click)="onEdit.emit(organizationType)"><i class="pencil icon"></i></button>
			<!-- <button class="ui circular tiny button" (click)="onDelete.emit(organizationType)"><i class="trash icon"></i></button> -->
			<button *isPermitted="{id:'ADMIN_ORGANIZATION_TYPE',action:'remove'}"  class="ui circular tiny button" (click)="onView.emit(organizationType)"><i class="eye icon"></i></button>

		</div>
</div>